import { render } from "./ModalUpdatePrice.vue?vue&type=template&id=580fc15c&scoped=true"
import script from "./ModalUpdatePrice.vue?vue&type=script&lang=js"
export * from "./ModalUpdatePrice.vue?vue&type=script&lang=js"

import "./ModalUpdatePrice.vue?vue&type=style&index=0&id=580fc15c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-580fc15c"]])

export default __exports__